import React, { useEffect, useState } from "react";
import { PromotionProduct } from "./PromotionProduct";
import { Link } from "react-router-dom";
import uniq from "lodash/uniq";
import BlankLink from "components/shared/BlankLink";
import { useStoreProduct } from "store/useStoreProduct";
import { formatPrice } from "utils/helpers";
import { SVGs } from "utils/svgs";

export default function ProductSection({
  theme,
  product,
  onClickRegister,
  preLink,
  isPrePage = false,
  isDeposit = true,
  colorText,
  index,
  indexPro,
  isplus,
  setProductConfigs,
  conDetail,
  isduo,
  setOpenModal //chi tiết sản phẩm popup
}) {
  const { titleSvg, _data } = product;


  const storages = uniq(_data.map((product) => product.capacityKey)).map(
    (x) => ({ storage: x, name: x })
  );
  const colors = uniq(_data.map((prod) => prod.colorKey));
  const images = _data.map((prod) => ({
    image: prod.imageUrl,
    color: prod.colorKey,
  }));

  const [colorSelected, setColorSelected] = useState(indexPro ? '#363636' : (index ? '#F2ADDA' : images[0]?.color));
  const [storageSelected, setStorageSelected] = useState(storages[0]?.storage);

  const imageSelected = images.find((image) => image.color === colorSelected);
  const prodSelected = _data.find(
    (prod) =>
      prod.colorKey === colorSelected && prod.capacityKey === storageSelected
  );

  const styleStorages = {
    background: "transparent",
    border: `1px solid ${theme === "light" ? "#333" : "#333"}`,
    borderRadius: "4px",
    padding: "9px 16px",
    cursor: "pointer",
    minWidth: " 80px",
    minHeight: "38px",
    color: `${theme === "light" ? "#333" : "#333"}`,
    textAlign: "center",
    fontFamily: "Arial",
    fontSize: "13px",
    fontStyle: "normal",
    fontWeight: "400",
    lineHeight: "20px",
    margin: "0 10px 0 0 !important",
  };

  const { setProdInScroll } = useStoreProduct();
  const handleScroll = () => {
    const section = document.getElementById(
      `product-section-${product?.prodSectionId}`
    );
    if (section) {
      const rect = section.getBoundingClientRect();
      if (rect.bottom >= 0 && rect.top <= window.innerHeight) {
        setProdInScroll(product?.prodSectionId);
      }
    }
  };

  // Sử dụng useEffect để thêm sự kiện scroll
  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const renderDepositButton = () => {
    if (isPrePage && prodSelected?.is_dknt !== true) {
      return (
        <>
          {prodSelected?.is_office === false ?
            // <div
            //   className="btn_deposit"
            //   style={{ cursor: 'not-allowed' }}
            // // data-popup-id="popup-registration"
            // >
            //   Tạm hết hàng
            // </div>
            <Link
              className="btn_deposit"
              to={{
                pathname: preLink,
                state: { productId: prodSelected.productId, isDeposit },
              }}
            >
              {isDeposit ? "Đặt hàng chờ" : "Mua ngay"}
            </Link>
            :
            <BlankLink
              className="btn_deposit"
              data-popup-id="popup-registration"
              onClick={() => window.open(`https://shopdunk.com${prodSelected?.path_office}`, "_blank")}
            >
              Mua ngay
            </BlankLink>
          }
        </>
      );
    } else {
      return (
        <div style={{ display: 'flex' }}>
          {/* <BlankLink
            className="btn_deposit"
            data-popup-id="popup-registration"
            onClick={prodLink}
          //onClick={() => window.open(getUrl(), "_blank")}
          >
            Tìm hiểu thêm
          </BlankLink> */}
          <BlankLink
            className="btn_deposit"
            data-popup-id="popup-registration"
            onClick={() => onClickRegister(prodSelected?.productId)}
          >
            Đăng ký nhận tin
          </BlankLink>
        </div>
      );
    }
  };

  return (
    <div className="container" id={`product-section-${product?.prodSectionId}`}>
      <div className="content-wrapper">
        <h2 className="title" style={{ fontSize: "40px", color: `${colorText}`, fontWeight: 500 }}>
          <img className="icon-apple" src={colorText === 'black' ? '../hm_service_image/icon_apple2.png' : '../hm_service_image/icon_apple.png'} alt="setting" />
          {titleSvg}
        </h2>
        {/* Chi tiết sản phẩm */}

        <div className="popup-info">
          <img src={SVGs.settting} alt="setting" />
          <a
            className="btn-popup"
            // href={getUrl()}           
            onClick={() => {
              setProductConfigs(conDetail);
              setOpenModal(true);
            }}
            target="_blank"
          >
            Chi tiết sản phẩm
          </a>
        </div>
        <PromotionProduct isduo={isduo} isplus={isplus} theme={theme} />


        {/* {!isProMax && <PromotionProduct theme={theme} />}  */}

        <div
          className="content-attrubite"
          style={{ display: "flex", justifyContent: "center" }}
        >
          <div className="attributes">
            <div
              className="product_attribute_input stogre"
              style={{ marginBottom: "25px" }}
            >
              <ul
                className="option-list"
                style={{
                  justifyContent: "center",
                  flexWrap: "nowrap",
                }}
              >
                {storages.map((storage, index) => (
                  <li
                    key={storage.storage}
                    onClick={() => setStorageSelected(storage.storage)}
                    style={{
                      border:
                        storage.storage === storageSelected
                          ? "2px solid #0066cc !important"
                          : "",
                    }}
                  >
                    <label
                      className={`${storageSelected === storage.storage
                        ? "checked-attr"
                        : ""
                        }`}
                      style={styleStorages}
                    >
                      {storage.storage}
                    </label>
                  </li>
                ))}
              </ul>
            </div>

            <div className="product_attribute_input color">
              <ul
                className="option-list attribute-squares color-squares"
                style={{ justifyContent: "center" }}
              >
                {colors.map((color, index) => (
                  <li
                    key={index}
                    className={`${colorSelected === color ? "selected-value" : ""
                      }`}
                    onClick={() => setColorSelected(color)}
                  >
                    <label>
                      <span
                        className="attribute-square-container"
                        alt={color}
                        style={{
                          backgroundColor: "transparent",
                          border: "unset!important",
                        }}
                      >
                        {" "}
                        <span
                          className="attribute-square"
                          style={{
                            backgroundColor: color,
                            display: "inline-block !important",
                            width: "28px !important",
                            height: "28px !important",

                            borderRadius: "100%",
                            boxShadow: "inset 1px 1px 2px rgb(0 0 0 / 10%)",
                          }}
                        ></span>
                      </span>
                    </label>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        <div className="price">
          <label>Chỉ từ:</label>
          <span>{formatPrice(prodSelected?.price)}đ</span>
          {/* <span>{formatPrice(productPrice)}đ</span> */}
        </div>
        {renderDepositButton()}
        <div id="image-wrapper-mobile" className="mobile-only-section">
          <img src={imageSelected?.image} alt="" width="100%" />
        </div>

      </div>
      <div className="image-wrapper desktop">
        <img src={prodSelected?.imageUrl} alt="" width="100%" />
      </div>
    </div>
  );
}
